import Vue from "vue";

const DEFAULT_SELECTOR = "[data-page-focus]";

export function usePageFocus(selector = DEFAULT_SELECTOR) {
  const focusMainContent = () => {
    if (typeof window === "undefined") {
      return;
    }

    Vue.nextTick(() => {
      const target = document.querySelector(selector);
      if (!target) {
        return;
      }

      if (!target.hasAttribute("tabindex")) {
        target.setAttribute("tabindex", "-1");
      }

      target.focus({ preventScroll: true });
    });
  };

  return { focusMainContent };
}
